import React from 'react';
import './DrillDownRow.scss';

interface DrillDownRowProps {
  stageName: string;
  stageColor: string;
  summaryText: string;
  bar: React.ReactNode;
  expanded: boolean;
  onToggle: () => void;
  children?: React.ReactNode;
}

export const DrillDownRow: React.FC<DrillDownRowProps> = ({
  stageName,
  stageColor,
  summaryText,
  bar,
  expanded,
  onToggle,
  children,
}) => (
  <div className={`ovp-drill ${expanded ? 'ovp-drill--open' : ''}`}>
    {/* Focusable via tabIndex, so it must also activate from the keyboard — Space is prevented from
        scrolling the page first. */}
    <div
      className="ovp-drill__row"
      onClick={onToggle}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onToggle();
        }
      }}
      role="button"
      tabIndex={0}
      aria-expanded={expanded}
    >
      <span className="ovp-drill__caret">{expanded ? '▾' : '▶'}</span>
      <span className="ovp-drill__dot" style={{ background: stageColor }} />
      <span className="ovp-drill__name">{stageName}</span>
      <span className="ovp-drill__summary">{summaryText}</span>
    </div>
    <div className="ovp-drill__bar">{bar}</div>
    {expanded && children && <div className="ovp-drill__detail">{children}</div>}
  </div>
);
